import { ClipboardCheck, MessageCircle, Search, ShoppingCart } from "lucide-react";

const STEPS = [
  {
    icon: Search,
    title: "Browse Products",
    text: "Review photographs, specifications and condition.",
  },
  {
    icon: ShoppingCart,
    title: "Add to Cart",
    text: "Select products and requested quantities.",
  },
  {
    icon: MessageCircle,
    title: "Send Your Enquiry",
    text: "Share your cart through WhatsApp.",
  },
  {
    icon: ClipboardCheck,
    title: "Confirm the Details",
    text: "Discuss availability, condition, delivery and payment before proceeding.",
  },
];

export default function HowToOrder() {
  return (
    <section id="how-to-order" className="scroll-mt-20 bg-forest-deep py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bronze-light">
          How to Order
        </p>
        <h2 className="mt-3 font-display text-3xl font-semibold text-cream sm:text-4xl">
          From browsing to booking in four steps
        </h2>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <div
                key={step.title}
                className="rounded-2xl border border-cream/15 bg-forest/40 p-6"
                data-testid={`order-step-${i + 1}`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex h-11 w-11 items-center justify-center rounded-full bg-bronze text-white">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </div>
                  <span className="font-display text-3xl font-semibold text-cream/25">
                    {i + 1}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold text-cream">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-cream/70">{step.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
